import React, { createContext } from "react";
import propTypes from "prop-types";

const ConfigContext: React.Context<any> = createContext({});

const defaultConfig = {
  env: process.env.REACT_APP_ENV || "",
  apiBase: process.env.REACT_APP_API_BASE || "",
  logInUrl: process.env.REACT_APP_LOGIN || "",
  bookfairs: process.env.REACT_APP_BF || "",
  cbsUrl: process.env.REACT_APP_CBS || "",
  reCaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_KEY || ''
};

function ConfigProvider({ value, children }: any) {
  return (
    <ConfigContext.Provider value={value}>
      {children}
    </ConfigContext.Provider>
  );
}

ConfigProvider.propTypes = {
  // need to specify (otherwise, eslint error)
  value: propTypes.shape,
  children: propTypes.node.isRequired,
};

ConfigProvider.defaultProps = {
  value: defaultConfig,
};

export { ConfigContext, ConfigProvider };
